import { render } from "./CustomAudio.vue?vue&type=template&id=57afd918&scoped=true&ts=true"
import script from "./CustomAudio.vue?vue&type=script&lang=ts"
export * from "./CustomAudio.vue?vue&type=script&lang=ts"

import "./CustomAudio.vue?vue&type=style&index=0&id=57afd918&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57afd918"]])

export default __exports__